import { testErrorListConstants } from "../_redux-constants";

export function testErrorListReducer(
  state = {
    testErrorsLoading: false,
    testErrorsData: null,
    testErrorListError: null,
  },
  action
) {
  switch (action.type) {
    case testErrorListConstants.TEST_ERRORS_LOADING:
      return Object.assign({}, state, {
        testErrorsLoading: true,
        testErrorListError: null,
        testErrorsData: null,
      });
    case testErrorListConstants.TEST_ERRORS_SUCCESS:
      return Object.assign({}, state, {
        testErrorsLoading: false,
        testErrorsData: action.data,
      });
    case testErrorListConstants.TEST_ERRORS_FAILURE:
      return Object.assign({}, state, {
        testErrorsLoading: false,
        testErrorsData: null,
        testErrorListError: action.error,
      });
    default:
      return state;
  }
}
